import Blockly from "blockly";
import helpers from "blocks/helpers";

Blockly.Blocks.SetY = {
  message0: "set y to %1",
  args0: [
    {
      type: "input_value",
      name: "y",
      check: "Number",
    },
  ],
  previousStatement: "Statement",
  nextStatement: "Statement",
};

Blockly.Blocks.SetY.init = function () {
  this.jsonInit(Blockly.Blocks.SetY);
};

Blockly.JavaScript.SetY = function (block) {
  const y = helpers.codeForArg("y", block);

  if (typeof y === "undefined") {
    return "";
  } else {
    return `visualisation.setY(${y});`;
  }
};
